import InputField from "components/fields/InputField";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInapi } from "Services/allApi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SignIn() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [adminData, setAdminData] = useState({
    username: "",
    password: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdminData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const token = localStorage.getItem("access");
    if (token) {
      navigate("/admin");
    }
  }, []);

  const handleSignin = async (e) => {
    e.preventDefault(); // Prevent default form submission

    if (adminData.username.trim() && adminData.password.trim()) {
      try {
        setIsLoading(true); // Show loading indicator
        const result = await signInapi(adminData);
        if (result.status === 200) {
          localStorage.setItem("access", result.data.access);
          setAdminData({ username: "", password: "" });
          navigate("/admin"); // Redirect after successful login
          toast.success("Login successful");
        } else {
          toast.error(result.response ? result.response.data : "Invalid Email/Password");
        }
      } catch (err) {
        console.error("Error during sign-in:", err);
        toast.error(err.response ? err.response.data : "Network error, please try again.");
      } finally {
        setIsLoading(false); // Ensure loading stops
      }
    } else {
      toast.error("Please fill in both fields.");
    }
  };

  return (
    <div className="mt-28 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Sign In
        </h4>

        {/* Form for handling Enter key */}
        <form onSubmit={handleSignin}>
          {/* Username */}
          <InputField
            variant="auth"
            extra="mb-3"
            label="Username*"
            placeholder="Enter your username"
            name="username"
            value={adminData.username}
            onChange={handleChange}
            type="text"
          />

          {/* Password */}
          <InputField
            variant="auth"
            extra="mb-3"
            label="Password*"
            placeholder="Enter your password"
            name="password"
            value={adminData.password}
            onChange={handleChange}
            type="password"
          />

          {/* Sign-in Button */}
          <button
            className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
            type="submit"
            disabled={isLoading} // Disable button during loading
          >
            {isLoading ? "Loading..." : "Sign In"}
          </button>
        </form>
      </div>
      <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeButton={true} />
    </div>
  );
}
